import classNames from 'clsx';
import React from 'react';

import styles from './styles.scss';

export interface Props {
  className?: string;
  children?: React.ReactNode;
  unpadded?: boolean;
}

const getClassNames = (props: Props) => classNames(props.className, styles.body);

const Body: React.FC<Props> = (props) => (
  <section className={getClassNames(props)}>{props.children}</section>
);

export default Body;
